module.exports = __webpack_public_path__ + "img/device_hub_color.fd8f47fa.svg";